import { Guard, isNumber, isType } from "../utils";
import { Goals } from "./goals";
import { FunctionFactory } from "survey-core";

function validateGoalWeight(params: any[]): boolean {
  if (params === undefined || params === null) return false;
  const weightRaw = params[0] as number | undefined;
  const goalWeight = params[1] as number | undefined;
  if (goalWeight != null && weightRaw != null && goalWeight < weightRaw) {
    return true;
  }
  return false;
}

const validateGoalWeightExpression = {
  name: 'validateGoalWeight',
  expression: "validateGoalWeight({weight}, {goalWeight})",
};

FunctionFactory.Instance.register('validateGoalWeight', validateGoalWeight);

const goalWeightQuestion = {
  name: "goalWeightPanel",
  visibleIf: `{goals} = "${Goals.LoseFat}"`,
  title: "What is your <div class='highlight'>ideal weight</div> that you want to reach?",
  description: "We’ll need this to come up with your personalized plan.",
  descriptionLocation: "underTitle",
  type: "multipletext",
  inputType: "number",
  items: [],
};

const goalWeightRaw = {
  visibleIf: `{goals} = "${Goals.LoseFat}"`,
  type: "text",
  inputType: "number",
  titleLocation: 'left',
  name: "goalWeight",
  isRequired: true,
  title: "{weightUnit}",
  placeholder: `Weight`,
  validators: [{
    type: "numeric",
    minValue: 25,
    text: "Please enter a valid weight.",
  }, {
    type: "expression",
    expression: "validateGoalWeight({weight}, {goalWeight})",
    text: "Your goal weight should be less than your current weight.",
  }],
};

export {
  goalWeightRaw,
  goalWeightQuestion,
  validateGoalWeightExpression,
}